// extracted by extract-css-chunks-webpack-plugin
module.exports = {"back-breadcrumb-no-separator":"back-breadcrumb-no-separator___1lUlS"};